<template>
  <div v-if="superUser" class="container">
    <header class="jumbotron">
      <h3>{{ $t('report.title_customer') }}</h3>
    </header>
    <div>
      <select v-model="selectedCustomer" class="form-control form-select" @change="onChange">
        <option disabled value="-1">
          {{ $t('report.select_customer') }}
        </option>
        <option v-for="(customer, index) in customers" :key="index" :value="customer.id">
          {{customer.firstName}} : ({{customer.phone}}) {{customer.email}}
        </option>
      </select>

      <div v-if="issues.length" class="issuesInfo">
        <div class="row">
          <div class="col-sm-2">
            ID
          </div>
          <div class="col-sm-1">
            Actividad
          </div>
          <div class="col-sm-3">
            Estado
          </div>
          <div class="col-sm-2">
            Fecha Creado
          </div>
          <div class="col-sm-4">
            Cliente
          </div>
        </div>
        <div v-for="(ticket, index) in issues" :key="index" class="row">
          <div class="col-sm-2">
            #{{ getTicketId(ticket) }}
          </div>
          <div class="col-sm-1">
            {{ getActive(ticket.active) }}
          </div>
          <div class="col-sm-3">
            <span v-if="ticket.status2">{{ticket.status2.name}}</span>
            <span v-else>Nuevo</span>
          </div>
          <div class="col-sm-2">
            {{formatDate(ticket.dateCreated)}}
          </div>
          <div class="col-sm-4">
            {{ticket.customer.firstName}} ({{ticket.customer.phone}})
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <header class="jumbotron">
      <h3>{{ $t('report.not_allowed') }}</h3>
    </header>
  </div>
</template>

<script>
import CustomerService from '@/services/customer.service';
import IssueService from '@/services/issue.service';
import { getTicketId, formatDate } from '@/utils/page-utils';

export default {
    name: 'CustomerReport',
    data() {
        return {
            issues: [],
            selectedCustomer: -1,
            superUser: false,
            customers: []
        };
    },
    created() {
        this.superUser = this.$store.state.auth.user.roles.includes('ROLE_ADMIN');
        if (this.superUser) {
            CustomerService.getCustomers().then(
                response => {
                    this.customers = response.data;
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        }
    },
    methods: {
        onChange() {
            IssueService.getCustomerTickets(this.selectedCustomer).then(
                response => {
                    this.issues = response.data;
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        formatDate,
        getTicketId,
        getActive(active) {
            return active ? '✓' : '✗';
        },
        // translateStatus(status) {
        //     if (status === 'New') {
        //         return 'Nuevo';
        //     } else if (status === 'Closed') {
        //         return 'Cerrado';
        //     } else if (status === 'InProgress') {
        //         return 'En Proceso';
        //     } else if (status === 'EstimateAccepted') {
        //         return 'Presupuesto Aceptado';
        //     } else if (status === 'WaitingForCustomer') {
        //         return 'En Espera Cliente';
        //     } else if (status === 'RequestedReplace') {
        //         return 'Solicitud de Cambio';
        //     } else if (status === 'Repaired') {
        //         return 'Reparado Correctamente';
        //     } else if (status === 'RepairedSancor') {
        //         return 'Reparado Sancor';
        //     } else if (status === 'NotRepaired') {
        //         return 'No Reparado';
        //     }
        //     return 'Desconocido';
        // }
    }
};
</script>
<style lang="scss">
.issuesInfo {
    margin-top: 10px;

    .row:first-child {
        font-weight: bold;
        border-bottom: 1px solid #AAA;
        padding-bottom: 10px;
        margin-bottom: 5px;
    }
}
</style>
